<template>
  <section>
    <gs-header title="Quản lý saler">
      <router-link :to="{name: 'saller-config'}" class="ui mini violet button"><i class="fa fa-cog"></i> Cấu hình chung</router-link>
      <router-link :to="{name: 'new-user'}" class="ui mini blue button"><i class="fa fa-plus"></i> Thêm mới</router-link>
    </gs-header>
    <div class="padding-sm-all">
      <gs-table
        :ref="salerTable"
        :table-name="salerTable"
        data-source="saller-salary"
        :data-params="filters"
        :data-sorted="sorted"
        :data-sorts="sorts"
        @remove-filter="removeFilter"
      >
        <section slot="filters">
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="block">
                <el-date-picker
                  size="small"
                  class="width-100"
                  v-model="filterDateRange"
                  type="daterange"
                  range-separator=" / "
                  @input="updateFilters"
                  format="MM-yyyy"
                  start-placeholder="Từ ngày"
                  end-placeholder="Đến ngày">
                </el-date-picker>
              </div>
            </el-col>
            <el-col :span="6">
              <el-select v-model="filters.sale_id" filterable placeholder="Chọn saler" @change="filter" class="width-100">
                <el-option
                  v-for="admin in administrators"
                  :key="admin.id"
                  :label="admin.name"
                  :value="admin.id">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
        </section>
        <template slot-scope="datas">
          <el-table
            :data="datas.data"
            border
            style="width: 100%">
          >
            <el-table-column
                label="#"
                width="80"
              >
                <template slot-scope="scope">
                  <small v-if="dataPaginations[salerTable]">{{(scope.$index + 1) + ((dataPaginations[salerTable].current_page -1) * dataPaginations[salerTable].per_page)}}</small>
                </template>
              </el-table-column>

            <el-table-column
              label="Saller"
              width="250"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.saler">
                  <p v-if="scope.row.saler.data.name"><i aria-hidden="true" class="fa fa-user"></i> <span class="click-copy">{{scope.row.saler.data.name}}</span></p>
                  <p v-if="scope.row.saler.data.phone"><i aria-hidden="true" class="fa fa-phone"></i> <span class="click-copy">{{scope.row.saler.data.phone}}</span></p>
                  <p v-if="scope.row.saler.data.email"><i aria-hidden="true" class="fa fa-envelope"></i> <span class="click-copy">{{scope.row.saler.data.email}}</span></p>
                  <p><i class="fa fa-calendar"></i> {{scope.row.month}}</p>
                </div>
              </template>
            </el-table-column>

            <el-table-column
              label="Đơn giá"
            >
              <template slot-scope="scope">
                <p>Đơn DS: <small class="pull-right text-red" style="font-size: 10px">{{commissionText(scope.row.config_salary.kpi)}}</small></p>
                <p>Đơn TL: <span class="pull-right text-red ">{{scope.row.config_salary.salary_accumulation | vnd}}</span></p>
                <p>Khách mới: <span class="pull-right text-red ">{{scope.row.config_salary.salary_by_customer | vnd}}</span></p>
                <p>&nbsp;</p>
              </template>
            </el-table-column>

            <el-table-column
              label="Đơn & Khách"
              width="130"
            >
              <template slot-scope="scope">
                <p>Đơn DS: <span class="pull-right">{{scope.row.total_new_shipment | number}}</span></p>
                <p>Đơn TL: <span class="pull-right">{{scope.row.total_accumulation_shipment | number}}</span></p>
                <p>Khách: <span class="pull-right">{{scope.row.total_new_customer | number}}</span></p>
                <p>&nbsp;</p>
              </template>
            </el-table-column>

            <el-table-column
              label="Lương"
              width="200"
            >
              <template slot-scope="scope">
                <p>Lương DS: <span class="text-red pull-right click-copy">{{scope.row.salary_commission | vnd}}</span></p>
                <p>Lương TL: <span class="text-red pull-right click-copy">{{scope.row.salary_accumulation | vnd}}</span></p>
                <p>Thưởng khách: <span class="text-red pull-right click-copy">{{scope.row.salary_new_customer | vnd}}</span></p>
                <p>Thưởng chỉ tiêu: <span class="text-red pull-right click-copy">{{scope.row.bonus | vnd}}</span></p>
                <p>Tổng lương: <span class="text-red pull-right click-copy">{{scope.row.salary | vnd}}</span></p>
              </template>
            </el-table-column>
             <el-table-column
              label="KPI"
              width="150"
            >
              <template slot-scope="scope">
                <p> KPI: <span class="pull-right">{{scope.row.kpi | number}}</span></p>
                <p> % KPI: <span class="pull-right">{{scope.row.kpi_percent | percent}}</span></p>
                <p class="text-right"><span :class="statusColor[scope.row.kpi_status]">{{scope.row.kpi_status_txt}}</span></p>
              </template>
            </el-table-column>

            <el-table-column
              width="55"
            >
              <template slot-scope="scope">
                <section class="padding-sm-top padding-sm-bottom">
                  <el-tooltip placement="top" content="Cấu hình lương" class="display-inline" v-if="scope.row.saler">
                    <router-link class="text-violet padding-all display-inline-block" :to="{name: 'saller-config-by-saler', params: {id: scope.row.saler.data.id}}"><i class="fa fa-cog"></i></router-link>
                  </el-tooltip>
                </section>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </gs-table>
    </div>
  </section>
</template>

<script>
import { debounce } from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import ls from 'local-storage'
import { formatDate, formatNumber } from 'src/helpers'
export default {
  name: 'Saller',
  data () {
    return {
      salerTable: 'salers',
      filterDateRange: '',
      filters: {
        sort: 'month:-1',
        include: 'saler',
        sale_id: '',
        start_date: '',
        end_date: ''
      },
      sorted: {
        month: -1
      },
      sorts: [
        {key: 'month', name: 'Ngày tạo'}
      ],
      statusColor: {
        '0': 'text-red',
        '1': 'text-green',
        '2': 'text-violet'
      }
    }
  },
  computed: {
    ...mapGetters('admin', ['administrators'])
  },
  methods: {
    ...mapActions('admin', ['getAllAdmins']),
    removeFilter () {
      this.reloadGsTable(this.salerTable)
      this.filterDateRange = ''
      this.filters = {
        sort: 'month:-1',
        include: 'saler'
      }
    },
    updateFilters (data) {
      this.filters.start_date = formatDate(data[0], 'YYYY-MM')
      this.filters.end_date = formatDate(data[1], 'YYYY-MM')
      this.filter()
    },
    commissionText (config) {
      let text = ''
      let kpi = Object.keys(config)
      kpi.forEach((v, i) => {
        if (i === 0 && parseInt(v) === -1) {
          text += v
        } else {
          if (i === 0) {
            text += `0-${v}: ${formatNumber(config[v], 0)}đ | `
          } else if (parseInt(v) !== -1) {
            text += `${kpi[i - 1]}-${v}: ${formatNumber(config[v], 0)}đ | `
          } else {
            text += `>${kpi[i - 1]}: ${formatNumber(config[v], 0)}đ`
          }
        }
      })
      return text
    },
    filter: debounce(function () {
      let lsFilter = ls.get('filters', {})
      if (!lsFilter) {
        lsFilter = {}
      }
      lsFilter[this.salerTable] = this.filters
      ls.set('filters', lsFilter)
      if (ls.get('doFilter')) {
        this.reloadGsTable(this.salerTable)
      }
    }, 300)
  },
  mounted () {
    this.clickToCopy()
    if (ls.get('filters') && ls.get('filters')[this.salerTable]) {
      this.filters = ls.get('filters')[this.salerTable]
      setTimeout(() => {
        ls.set('doFilter', true)
      }, 100)
    }
    if (!this.administrators.length) {
      this.getAllAdmins({role_name: 'saler', limit: -1})
    }
    this.listenReloadGsTable()
    this.sorted = this.getSorted(this.salerTable)
  },
  beforeRouteEnter (to, from, next) {
    if (from.fullPath === '/') {
      ls.remove('filters')
      ls.set('doFilter', true)
    } else {
      if (ls.get('filters') && ls.get('filters')['clients']) {
        ls.set('doFilter', false)
      } else {
        ls.set('doFilter', true)
      }
    }
    next()
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// Saler.vue?afc66954